import { render, staticRenderFns } from "./MobileFeedItem.vue?vue&type=template&id=0f28ef05&scoped=true"
import script from "./MobileFeedItem.vue?vue&type=script&lang=js"
export * from "./MobileFeedItem.vue?vue&type=script&lang=js"
import style0 from "./MobileFeedItem.vue?vue&type=style&index=0&id=0f28ef05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f28ef05",
  null
  
)

export default component.exports